import $ from 'jquery';
import Swiper, { Navigation, Thumbs, Pagination, Scrollbar } from 'swiper';
/**
 * @description Activate product image gallery
 */ export const init = async function() {
    const sections = $('.js-product-gallery-desktop');
    sections.each(function(_, sElement) {
        const section = $(sElement);
        const imageCarousel = section.find('.js-product-gallery-images-desktop');
        const imageSwiperContainerElement = imageCarousel.find('.swiper-container').first().get(0);
        if (!imageSwiperContainerElement) {
            return;
        }
        const thumbsSwiper = new Swiper('.js-swiper-thumbs-pdp-desktop', {
            spaceBetween: 12,
            slidesPerView: 6,
            freeMode: true,
            autoHeight: false,
            modules: [
                Navigation,
                Scrollbar
            ],
            watchSlidesProgress: true,
            direction: 'vertical',
            scrollbar: {
                el: '.js-swiper-thumbs-pdp-desktop .swiper-scrollbar',
                draggable: true
            },
            navigation: {
                nextEl: '.js-swiper-thumbs-pdp-desktop .swiper-button-next',
                prevEl: '.js-swiper-thumbs-pdp-desktop .swiper-button-prev'
            }
        });
        const imageSwiper = new Swiper(imageSwiperContainerElement, {
            autoHeight: false,
            direction: 'horizontal',
            init: false,
            loop: false,
            slidesPerView: 1,
            modules: [
                Navigation,
                Thumbs,
                Pagination
            ],
            centerInsufficientSlides: false,
            centeredSlides: false,
            thumbs: {
                swiper: thumbsSwiper
            },
            pagination: {
                el: '.js-pagination-desktop'
            },
            breakpoints: {
                1024: {
                    direction: 'vertical'
                }
            }
        });
        thumbsSwiper.init();
        imageSwiper.init();
        let abTestInterval = null;
        const filterImagesByVariation = (key)=>{
            const hasImages = document.querySelector(`[data-ab-variation="${key}"]`) !== null;
            if (!hasImages) {
                return;
            }
            const images = [
                ...Array.from(imageSwiper.slides),
                ...Array.from(thumbsSwiper.slides)
            ];
            images.forEach((slide)=>{
                if (slide.getAttribute('data-ab-variation') !== `${key}`) {
                    slide.remove();
                } else {
                    slide.setAttribute('data-is-slide-hidden', 'false');
                }
            });
            imageSwiper.update();
            thumbsSwiper.update();
        };
        function checkImageABTest() {
            const abTestVariation = document.body.getAttribute('data-images-variation');
            if (abTestVariation) {
                abTestInterval && clearInterval(abTestInterval);
                if (abTestVariation === 'studio') {
                    filterImagesByVariation('STUDIO');
                }
                if (abTestVariation === 'lifestyle') {
                    filterImagesByVariation('STUDIO_LIFESTYLE');
                }
            }
        }
        abTestInterval = setInterval(checkImageABTest, 100);
    });
};
